import { useState, useEffect, useRef } from "react";
import { Box, CardMedia, colors } from "@mui/material";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

type Props = {
    imageURL: string,
    width?: string,
    height?: string,
    mr?: string,
    borderRadius?: string,
    color?: string,
    onLoadStatus?: (loaded: boolean) => void;
}

const ImageLoader = ({ imageURL, height, width, mr, borderRadius, onLoadStatus, color}: Props) => {

    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const currentImageURL = useRef<string>(imageURL);

    useEffect(() => {
        if (imageURL !== currentImageURL.current) {
            setIsImageLoaded(false);
            onLoadStatus?.(false);
            currentImageURL.current = imageURL;
        }
    }, [imageURL, onLoadStatus]);

    useEffect(() => {
        if (imageURL) {
            const img = new Image();
            img.src = imageURL;

            const handleImageLoad = () => {
                setIsImageLoaded(true);
                onLoadStatus?.(true);
            };

            const handleImageError = () => {
                console.error("Image failed to load");
                setIsImageLoaded(false);
                onLoadStatus?.(false);
            };

            img.onload = handleImageLoad;
            img.onerror = handleImageError;

            // Cleanup the image load listener in case the component unmounts or the URL changes
            return () => {
                img.onload = null;
                img.onerror = null;
            };
        }
    }, [imageURL, onLoadStatus]);

    return (
        <Box>
        {!isImageLoaded && (
            <HelpOutlineOutlinedIcon 
            sx={{
                width: "25px",
                height: "25px",
                mr: mr ? mr : "0px",
                display: "flex",
                alignContent: "center",
                alignItems: "center",        
                justifyContent: "center",   
                color: color ? color : "#ffffff"
            }}
            />
        )}
        {isImageLoaded && currentImageURL && (
            <CardMedia
            sx={{ 
                height: height ? height : "100%",
                width: width ? width : "100%",
                mr: mr ? mr : "0px",
                borderRadius: borderRadius ? borderRadius : "0px"
            }}
            component="img"
            src={imageURL}
            />
        )}
        </Box>
    );
};

export default ImageLoader;